import { render, staticRenderFns } from "./DefaultContent-Category.vue?vue&type=template&id=997e6e18&"
import script from "./DefaultContent-Category.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-Category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports